// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"
import ChartController from "./chart_controller"
import MapController from "./map_controller"

application.register("chart", ChartController)
application.register("map", MapController)
